@if (missingCountDetails?.missingModelCount || missingCountDetails?.missingAccountCount || missingCountDetails?.tlhExpirationCount) {
  <div class="quickFiltersLayout">
    @if (missingCountDetails?.missingModelCount) {
      <div tooltip [tooltipTitle]='modelToolTip' [tooltipWidth]='243'
        [ngClass]="missingCountDetails?.withoutModel?'quicklinkstyle':''" [tooltipVerticalOffset]='8'
        [tooltipHorizontalOffset]='8' (click)="filterMissingModel($event)" class="quick-filter-list quick-filter-list1">
        <img class="quick-icons" src="../../assets/images/exclamation-circle.png">Missing models
      ({{missingCountDetails?.missingModelCount}})</div>
    }
    @if (missingCountDetails?.missingAccountCount) {
      <div tooltip [tooltipTitle]='accountToolTip'
        [tooltipVerticalOffset]='8' [tooltipHorizontalOffset]='8' [tooltipWidth]='243'
        [ngClass]="missingCountDetails?.withoutAccount?'quicklinkstyle':''" (click)="filterMissingAccount($event)"
        class="quick-filter-list quick-filter-list1">
        <img class="quick-icons" src="../../assets/images/exclamation-circle.png">Missing accounts
      ({{missingCountDetails?.missingAccountCount}})</div>
    }
    @if (missingCountDetails?.tlhExpirationCount) {
      <div [ngClass]="missingCountDetails?.taxlossResults?'quicklinkstyle':''"
        (click)="filterTlhCount($event)" class="quick-filter-list quick-filter-list1">
        <img class="quick-icons" src="../../assets/images/exclamation-circle.png">TLH expiration
      ({{missingCountDetails?.tlhExpirationCount}})</div>
    }
  </div>
}
